// @flow

export default {
  LANGUAGE_SWITCH: 'l',
  POSTLOGIN_ACTION: 'pla',
  VOUCHER_CODE: 'code',
};
